module.exports = __webpack_public_path__ + "static/media/id_1.0d119465.jpg";